import { FC } from "react";
import { Button, ButtonProps, Spinner } from "react-bootstrap";
import FlexBox from "./flex-box";

interface SimpleButtonProps extends ButtonProps {
  value?: string;
  suffixIcon?: React.ReactNode;
  prefixIcon?: React.ReactNode;
  isLoading?: boolean;
  isBlockButton?: boolean;
}

const SimpleButton: FC<SimpleButtonProps> = ({
  isLoading,
  suffixIcon,
  prefixIcon,
  isBlockButton = false,
  value,
  ...props
}) => {
  return (
    <Button
      {...props}
      disabled={isLoading || props.disabled}
      className={`${props.className} ${isBlockButton && "w-100"}`}
    >
      {isLoading ? (
        <Spinner animation="border" variant="warning" className="loading" />
      ) : (
        <FlexBox className="w-100">
          {prefixIcon}
          <div className="text-center w-100">{value ?? props.children}</div>
          {suffixIcon}
        </FlexBox>
      )}
    </Button>
  );
};

export default SimpleButton;
